import BaseStartInvest from "../components/forms/base-start-invest/BaseStartInvest";

function StartInvest() {
    return ( <BaseStartInvest/> );
}

export default StartInvest;